module.exports = __webpack_public_path__ + "img/busca-avancada-peixes-aquario-2.dee9eb99.jpg";